<template>
  <v-container class="form-container">
    <!-- Added transition between phone and OTP screens -->
    <transition name="slide-fade" mode="out-in">
      <div v-if="codeSent === false" key="phone-screen" class="form-content">
        <div class="text-center slide-in-up">
          <h1 class="welcome-title">ברוכים הבאים!</h1>
          <p class="welcome-subtitle">אנא הכניסו את מספר הפלאפון שלכם שאתו</p>
          <p class="welcome-subtitle">נרשמתם למערכת</p>
        </div>

        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="input-wrapper slide-in-up" style="animation-delay: 0.1s;">
            <v-text-field class="custom-text-field" type="number" hide-spin-buttons hide-details
              @keydown.enter="handleEnterKey" v-model="account_id" label="הקלד כאן" solo text></v-text-field>
          </div>
        </v-form>

        <div class="button-wrapper slide-in-up" style="animation-delay: 0.2s;">
          <v-btn @click="sendAuth" class="gradiant-bt custom-button" dark elevation="4" text>
            <span class="button-text">המשך</span>
          </v-btn>
        </div>

        <div class="alternative-login slide-in-up" style="animation-delay: 0.3s;"
          @click="$router.replace('/login-user')">
          <span class="alternative-text">או הכנסו באמצעות שם משתמש וסיסמה</span>
        </div>
      </div>

      <div v-else key="otp-screen" class="form-content">
        <div class="text-center slide-in-up">
          <h1 class="welcome-title">הכנס קוד אימות</h1>
        </div>

        <div class="sms-icon-wrapper slide-in-up" style="animation-delay: 0.1s;">
          <div class="icon-circle pulse">
            <img src="../../../assets/icon_sms.svg" class="sms-icon">
          </div>
        </div>

        <div class="text-center slide-in-up" style="animation-delay: 0.2s;">
          <p class="welcome-subtitle">ברגעים אלו ממש נשלח אליך sms</p>
          <p class="welcome-subtitle">אנא הכנס את קוד האימות שנשלח אליך</p>
        </div>

        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="input-wrapper slide-in-up" style="animation-delay: 0.3s;">
            <v-text-field v-model="smsCode" ref="otpField" label="הכנס קוד אימות" class="custom-text-field" outlined
              dense type="number" hide-spin-buttons hide-details solo flat :rules="[v => !!v || 'שדה חובה']"
              @keydown.enter="handleEnterKeySms"></v-text-field>
          </div>
        </v-form>

        <div class="resend-wrapper slide-in-up" style="animation-delay: 0.4s;">
          <span @click="resend" class="resend-text">לא קיבלתי, נא לשלוח שוב</span>
        </div>

        <div class="button-wrapper slide-in-up" style="animation-delay: 0.5s;">
          <v-btn @click="smsVerify" dark rounded class="gradiant-bt custom-button" elevation="4">
            <span class="button-text">המשך</span>
          </v-btn>
        </div>
      </div>
    </transition>

    <v-row v-if="progressShow" class="progress-row">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="white" size="50"></v-progress-circular>
      </v-col>
    </v-row>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {

  components: {
    SnackBar
  },

  data: () => ({
    isResponsive: false,
    account_id: "",
    verifyCode: "",
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    codeSent: false,
    smsCode: "",
    username: "",
    password: "",
  }),
  methods: {

    async loginByPhone() {

      this.progressShow = true
      let MyJSON = JSON.stringify({ account_id: this.account_id });
      let api = process.env.VUE_APP_BASE_URL + "/auth/login"

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        this.progressShow = false;
        const jsonObject = await response.json();
        if (response.status >= 400) {
          this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
        } else if (response.status === 200) {
          this.showSnackBar("הזיהוי עבר בהצלחה, נשלח סמס לאימות", "green");
          localStorage.setItem("accountId", this.account_id)
          this.codeSent = true;
          this.focusOtpField();
        }
      } catch (error) {
        this.showSnackBar("Error Login: " + error, "red");
      }

    },
    async smsVerify() {
      if (this.$refs.form.validate()) {

        this.progressShow = true
        const accountId = localStorage.getItem("accountId");
        let MyJSON = JSON.stringify({ account_id: accountId, smsCode: this.smsCode });
        let api = process.env.VUE_APP_BASE_URL + "/auth/verify_code"

        try {
          const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
          this.progressShow = false;
          const jsonObject = await response.json();
          if (response.status >= 400) {
            this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
          } else if (response.status === 200) {
            this.showSnackBar("התחברת בהצלחה!", "green");
            localStorage.setItem('token', jsonObject.token);
            this.$router.replace({ name: "callHistory" })
          }
        } catch (error) {
          this.showSnackBar("Error Login: " + error, "red");
        }

      }
    },
    sendAuth() {
      this.loginByPhone();
    },
    async resend() {

      this.progressShow = true
      const accountId = localStorage.getItem("accountId");
      let MyJSON = JSON.stringify({ account_id: accountId });
      let api = process.env.VUE_APP_BASE_URL + "/auth/login"

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        this.progressShow = false;
        if (response.status >= 400) {
          this.showSnackBar("שגיאה בשליחת סמס", "red");
        } else if (response.status === 200) {
          this.showSnackBar("סמס נשלח בהצלחה!", "green");
        }
      } catch (error) {
        this.showSnackBar("Error Login: " + error, "red");
      }

    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    focusOtpField() {
      this.$nextTick(() => {
        if (this.$refs.otpField) {
          this.$refs.otpField.focus();
        }
      });
    },
    handleEnterKey() {
      if (this.account_id) {
        this.loginByPhone();
      }
    },
    handleEnterKeySms() {
      if (this.codeSent) {
        this.smsVerify();
      }
    },
  },
  watch: {
    $route() {
      document.title = 'Login Phone | CLICK-CALL'
    },
  },
}
</script>
<style scoped>
/* Added container styling with better positioning */
.form-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  max-width: 90%;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.form-content {
  width: 100%;
}

/* Enhanced typography with better spacing */
.welcome-title {
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.welcome-subtitle {
  color: white;
  font-size: 16px;
  margin: 4px 0;
  opacity: 0.95;
  line-height: 1.5;
}

/* Improved input field styling */
.input-wrapper {
  margin-top: 30px;
  width: 100%;
}

.custom-text-field>>>.v-input__control .v-input__slot {
  background-color: white;
  border-radius: 20px;
  border: 2px solid #0052cc;
  padding: 8px 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 82, 204, 0.15);
}

.custom-text-field>>>.v-input__control .v-input__slot:hover {
  border-color: #0066ff;
  box-shadow: 0 6px 16px rgba(0, 82, 204, 0.25);
  transform: translateY(-2px);
}

.custom-text-field>>>.v-input__control .v-input__slot:focus-within {
  border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 82, 204, 0.2);
}

/* Enhanced button styling with hover effects */
.button-wrapper {
  margin-top: 24px;
  width: 100%;
}

.custom-button {
  width: 100%;
  border-radius: 20px;
  padding: 20px 16px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.custom-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.custom-button:hover::before {
  width: 300px;
  height: 300px;
}

.custom-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(9, 104, 224, 0.4) !important;
}

.custom-button:active {
  transform: translateY(-1px);
}

.button-text {
  font-weight: bold;
  font-size: 18px;
  position: relative;
  z-index: 1;
}

.gradiant-bt {
  background: linear-gradient(94deg, rgba(140, 159, 245, 1) 1%, rgba(9, 104, 224, 1) 70%);
}

/* SMS icon styling with pulse animation */
.sms-icon-wrapper {
  text-align: center;
  margin: 30px 0;
}

.icon-circle {
  display: inline-block;
  background-color: aliceblue;
  padding: 25px;
  border-radius: 50%;
  box-shadow: 0 8px 24px rgba(0, 82, 204, 0.2);
}

.sms-icon {
  width: 60px;
  height: 60px;
  display: block;
}

.pulse {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 8px 24px rgba(0, 82, 204, 0.2);
  }

  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 32px rgba(0, 82, 204, 0.3);
  }
}

/* Alternative login link styling */
.alternative-login {
  margin-top: 30px;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s ease;
}

.alternative-login:hover {
  transform: translateY(-2px);
}

.alternative-text {
  color: white;
  font-size: 15px;
  text-decoration: underline;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.alternative-login:hover .alternative-text {
  opacity: 1;
}

/* Resend link styling */
.resend-wrapper {
  text-align: center;
  margin-top: 16px;
}

.resend-text {
  color: white;
  cursor: pointer;
  font-size: 15px;
  text-decoration: underline;
  opacity: 0.9;
  transition: all 0.3s ease;
}

.resend-text:hover {
  opacity: 1;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

/* Progress indicator styling */
.progress-row {
  margin-top: 20px;
}

/* Slide-in-up animation for form elements */
.slide-in-up {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Transition between screens */
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter {
  transform: translateX(30px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-30px);
  opacity: 0;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .form-container {
    width: 95%;
    padding: 30px 20px;
  }

  .welcome-title {
    font-size: 28px;
  }

  .welcome-subtitle {
    font-size: 14px;
  }

  .button-text {
    font-size: 16px;
  }
}

@media (max-width: 400px) {
  .form-container {
    padding: 25px 15px;
  }

  .welcome-title {
    font-size: 24px;
  }

  .sms-icon {
    width: 50px;
    height: 50px;
  }
}
</style>
